import '../../Styles/Sass/CleanerDetail.scss';

function CleanerDetail(props){

  const concatArray = (array) => {
    if (array) {
      let returnString = '';
      array.forEach(word => {
        returnString = returnString.concat(`${word[0].toUpperCase() + word.slice(1)} `)
      });
      return returnString;
    }
  }

  return(
    <section className='cleanerdetail'>
      <h3 className='cleanerdetail__text cleanerdetail__text--subtitle'>Description:</h3>
      <p className='cleanerdetail__text cleanerdetail__text--detail'>{props.description}</p>
      <h3 className='cleanerdetail__text cleanerdetail__text--subtitle'>Service Provided:</h3>
      <p className='cleanerdetail__text cleanerdetail__text--detail'>{concatArray(props.services)}</p>
      <h3 className='cleanerdetail__text cleanerdetail__text--subtitle'>Availability:</h3>
      <p className='cleanerdetail__text cleanerdetail__text--detail'>{concatArray(props.availability)}</p>
    </section>
  );
}
export default CleanerDetail;